import React, { Component } from 'react';
import CpLoading from '../../components/CpLoading';
import './detail.less';
import { Table, Radio, message } from 'antd';
import { enquiryOrder, enquiryPurchase } from './api';
import { amountToString } from '../../util/tool';
const STATUS = {
  10: '未采购',
  20: '已采购'
};
const radioStyle = {
  display: 'block',
  height: '90px',
  lineHeight: '45px',
};
export default class detail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orderInfo: {

      },
      loading: true,
      selectedRows: [], //选中的数据
      isChecked: false,
      selectedRowsKeys:[],//
      list:[]
    };
  }
  columns = [
    {
      title: '商品',
      dataIndex: 'sku_name',
      align: 'center',
      width: 200,
      render: (text, record) => {
        return <div className='order-table-content order-table-good'
        >
          <div>商品名称：<span>{record?.sku_name}</span></div>
          <div>规格：<span>{record?.sale_norms}</span></div>
        </div>;
      }
    },
    {
      title: '供应商',
      dataIndex: 'company_name',
      align: 'center',
      width: 200,
      render: (text, record) => {
        if (record?.purchase_order_no) {//已采购
          return <div className='order-table-content  order-table-center'>{record?.purchased?.company?.name}</div>;
        } else {
          if (record?.quotes?.length > 0) {
            return <div className='order-table-content  order-table-center order-company'>{
              record?.quotes.map(item => {
                return <div key={item.id}>{item?.company?.name}</div>;
              })
            }</div>;
          } else {
            return '';
          }
        }
      }
    },
    {
      title: '单价',
      dataIndex: 'sale_price',
      align: 'center',
      render: (text, record) => {
        if (record?.purchase_order_no) {//已采购
          return '￥ ' + amountToString(record?.purchased?.quote_price);
        } else {
          if (record?.quotes?.length > 0) {
            return <div className='order-table-content order-table-center'>{
              record?.quotes.map(item => {
                return <div key={item.id}>￥ {amountToString(+(item?.quote_price))}</div>;
              })
            }</div>;
          } else {
            return '';
          }
        }
      }
    },
    {
      title: '税率',
      dataIndex: 'tax_rate',
      align: 'center',
      render: (text, record) => {
        if (record?.purchase_order_no) {//已采购
          return <span>{record?.purchased?.tax_rate} %</span>;
        } else {
          if (record?.quotes?.length > 0) {
            return <div className='order-table-content order-table-center'>{
              record?.quotes.map(item => {
                return <div key={item.id}>{item?.tax_rate} %</div>;
              })
            }</div>;
          } else {
            return '';
          }
        }
      }
    },
    {
      title: '含税单价',
      dataIndex: 'tax_sale_price',
      align: 'center',
      render: (text, record) => {
        if (record?.purchase_order_no) {//已采购
          return '￥ ' + amountToString(record?.purchased?.tax_sale_price);
        } else {
          if (record?.quotes?.length > 0) {
            return <div className='order-table-content order-table-center'>{
              record?.quotes.map(item => {
                return <div key={item.id}>￥ {amountToString(item?.tax_sale_price)}</div>;
              })
            }</div>;
          } else {
            return '';
          }
        }
      }
    },
    {
      title: '数量',
      dataIndex: 'sale_number',
      align: 'center',
      render: (text, record) => {
        if (record?.purchase_order_no) {//已采购
          return 'X ' + (+record?.sale_number);
        } else {
          if (record?.quotes?.length > 0) {
            return <div className='order-table-content order-table-center'>{
              record?.quotes.map(item => {
                return <div key={item.id}>X {(+record?.sale_number)}</div>;
              })
            }</div>;
          } else {
            return 'X ' + (+record?.sale_number);
          }
        }
      }
    },
    {
      title: '小计',
      dataIndex: 'tax_sale_price_total',
      align: 'center',
      render: (text, record) => {
        if (record?.purchase_order_no) {//已采购
          return '￥ ' + amountToString(record?.purchased?.tax_sale_price_total);
        } else {
          if (record?.quotes?.length > 0) {
            return <div className='order-table-content order-table-center'>{
              record?.quotes.map(item => {
                return <div key={item.id}>￥ {amountToString(item?.tax_sale_price_total)}</div>;
              })
            }</div>;
          } else {
            return '';
          }
        }
      }
    },
    {
      title: '选择',
      dataIndex: 'choose',
      align: 'center',
      render: (text, record, index) => {
        if (record?.purchase_order_no) {//已采购
          return <div>
            <div>采购单号:</div>
            <span onClick={() => { this.handlePush(record); }}
              className='title'>{record?.purchase_order_no}</span>
          </div>;
        } else {
          if (record?.quotes?.length > 0) {
            return <div>
              <Radio.Group
              onChange={(value) => { this.handleChangeRadio(value, record, index); }}
            >{
                record?.quotes.map((item) => {
                  return <Radio
                    key={item.id}
                    value={item.id}
                    style={radioStyle}
                  ></Radio>;
                })
              }</Radio.Group>
            </div>;
          } else {
            return '';
          }
        }
      }
    }
  ]
  handlePush = (record) => {
    this.props.history.push(`/basic/user/order/detail/${record?.purchase_order_no}/0`);
  }
  handleChangeRadio = (e, record, index) => {
    const { selectedRows ,list} = this.state ;
    for(var i=0; i< record?.quotes.length; i++){
      if(record?.quotes.length>0){
        list[index].quotes[i].isSelected=false;
        if(record?.quotes[i].id === e.target.value){
          list[index].quotes[i].isSelected=true;
           selectedRows.push(record?.quotes[i]);
         }
      }
    }
    this.setState({
      list,
      selectedRows,
      isChecked: true
    });
  }
  handleCreate = () => {
    const { selectedRows, isChecked } = this.state;
    let arr=selectedRows.filter(item=>item.isSelected===true);
    if (isChecked) {
      enquiryPurchase({
        order_no: this.orderId,
        quotes: arr
      }).then(res => {
        if (res.data && res.data.code === 0) {
          message.success(res.data.msg);
          this.setState({
            selectedRows: [],
            isChecked: false
          }, () => {
            this.getDetail();
          });
        } else {
          message.error(res.data.msg);
        }
      });
    } else {
      return;
    }

  }
  orderId = this.props.match.params.id;
  componentDidMount() {
    this.getDetail();
  }
  componentWillUnmount() {
    this.setState = () => false;
  }
  getDetail = () => {
    enquiryOrder({
      order_no: this.orderId
    }).then(res => {
      if (res.data && res.data.code === 0) {
        const { data } = res.data;
        // eslint-disable-next-line no-unused-expressions
        let list1= data?.products?.map(itm=>{
          if(itm?.quotes&& itm?.quotes.length>0){
           let item = itm.quotes.map(val=>{
              return {
                ...val,
                isSelected:false,
              };
            });
            return {
              ...itm,
              quotes: item
            };
          }
          return itm;
      });
      // console.log(list1);
        this.setState({
          loading: false,
          orderInfo: data,
          list: list1,
        });
      }
    });
  }

  render() {
    const { orderInfo = {}, loading, isChecked ,list} = this.state;

    return (
      <div className='enquiry-detail'>
        {loading ? <CpLoading size="large" className="cp-loading" /> : null}
        <div className="order-process">
          <div className="order-process-content">
            <div className="order-process-content-item">
              <div>询价单号：{orderInfo?.order_no}</div>
              <div >状态：<span >
                {
                  STATUS[orderInfo?.order_status]
                }
              </span></div>
            </div>
          </div>
        </div>
        <div className="order-detail-info">
          <div className="left">
            <div className="item mb-20"><span>创建时间：</span>{orderInfo?.create_time}</div>
            <div className="item mb-20"></div>
            <div className="item"><span>期望到货时间：</span>{orderInfo?.expected_date}</div>
          </div>
          <div className="right">
            <div className="item mb-20"><span>收货人：</span>{orderInfo?.consignee_name}</div>
            <div className="item mb-20"><span>收货地址：</span>{orderInfo?.province_name}{orderInfo?.city_name}{orderInfo?.district_name}{orderInfo.address}</div>
            <div className="item"><span>手机号：</span>{orderInfo?.consignee_mobile}</div>
          </div>
        </div>
        <div className='order-detail-create' onClick={this.handleCreate} ><div className={isChecked ? 'active-button' : 'default-button'}>创建采购单</div></div>
        <div className="order-product-list">
          <Table
            rowKey={(record) => record.id}
            bordered
            dataSource={list}
            columns={this.columns}
            className='order-product-table'
            pagination={false}
          />
        </div>
      </div>
    );
  }
}
